import type { OwnTeamCells, PanelCells } from '../types';

/** #616 — the roles that see the statistics of every official and the
 *  quality numbers (operator, 2026-10-17). The backend holds the same list
 *  (`ALL_OFFICIAL_STATS_ROLES`, middleware/auth.ts) and enforces it: the
 *  frontend uses it to decide what to show. A `referee` with none of these
 *  roles sees only the own page. */
export const ALL_OFFICIAL_STATS_ROLES = ['admin', 'tournament_manager', 'jury'] as const;
/** The roles that see the Officials entry of the menu. */
export const OFFICIAL_STATS_ROLES = [...ALL_OFFICIAL_STATS_ROLES, 'referee'] as const;

// #661, F44 — the arithmetic of the quality numbers of an official. The
// server sends the cells (`PanelCells`, `OwnTeamCells`); each view adds them
// with the functions below, so a rule of the operator has one place.

/** The cards that the panel and the jury compared: the four cells. */
export const panelCompared = (c: PanelCells): number => c.consensus + c.panel_overruled + c.dissent_upheld + c.dissent_overruled;
/** The cards with the panel: the consensus and the cards that the panel overruled. */
export const panelWith = (c: PanelCells): number => c.consensus + c.panel_overruled;
/** The own-team cards of one kind (the rounds or the WP bouts): the three cells. */
export const ownTeamRounds = (c: OwnTeamCells): number => c.for_own + c.with_jury + c.against_own;
/** The bias measure: the own-team cards against the jury decision. A card for
 *  the own corner and a card against it both count, and never a net balance:
 *  a bias in one direction does not cancel a bias in the other (operator,
 *  2026-10-22, #641, #644). */
export const ownTeamAgainstJury = (c: OwnTeamCells): number => c.for_own + c.against_own;
/** A whole percent, or null with no total. The caller writes its own text for null. */
export const rate = (hits: number, total: number): number | null => (total > 0 ? Math.round((hits / total) * 100) : null);
